module.exports = __webpack_public_path__ + "static/media/kitImage.25b2571f.png";